export default __webpack_public_path__ + "static/media/element_59.57216f7b.webp";